import { UserSessionService } from './../../UserSession/user-session.service';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

/**
 * Componente que renderiza el visor de Framelinks
 */
@Component({
  selector: 'ngx-framelink-viewer',
  templateUrl: './framelink-viewer.component.html',
  styleUrls: ['./framelink-viewer.component.scss']
})
export class FramelinkViewerComponent implements OnInit {

  currentframelink: string = "https://agroguia-classic.carto.com/u/valtravieso/builder/a40b4a77-e952-4b08-b557-d45cc908c4fd/embed";
  urlSafe: SafeResourceUrl;
  constructor(private route: ActivatedRoute,private usersessionservice: UserSessionService,
    public sanitizer: DomSanitizer) {


     }

     /**
      * @ignore
      */
 ngOnInit(): void {
  this.route.paramMap.subscribe((params) => {
    console.log(decodeURIComponent(params.get('urllink')));
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(decodeURIComponent(params.get('urllink')));
  });

  }

}
